export default __webpack_public_path__ + "static/open-graph-dae3c11c4798c9ab32cd76625156fb06.png";